import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import LocalServicesHero from './components/LocalServicesHero';
import LocalServicesPainPoints from './components/LocalServicesPainPoints';
import LocalServicesHowHelps from './components/LocalServicesHowHelps';
import LocalServicesExamples from './components/LocalServicesExamples';
import LocalServicesHowItWorks from './components/LocalServicesHowItWorks';
import LocalServicesBenefits from './components/LocalServicesBenefits';
import LocalServicesFAQ from './components/LocalServicesFAQ';
import LocalServicesCTA from './components/LocalServicesCTA';

export default function LocalServicesPage() {
  return (
    <>
      <title>AI Ads for Local Services | Get More Calls & Bookings | AdForge</title>
      <meta
        name="description"
        content="AI ads for local services that keep your phone ringing. AdForge creates Facebook ads, Google ads, and Instagram ads for plumbers, cleaners, HVAC, and more in minutes. No marketing experience needed. Try free."
      />
      <meta
        name="keywords"
        content="AI ads for local services, local service advertising, facebook ads for local business, google ads for service businesses, local service lead generation, service business ad generator"
      />
      <link rel="canonical" href="https://adforge.ai/ai-ads-for-local-services" />
      <meta name="Last-modified" content={new Date().toISOString().split('T')[0]} />

      <meta property="og:type" content="website" />
      <meta property="og:title" content="AI Ads for Local Services | AdForge — Get More Calls & Bookings" />
      <meta
        property="og:description"
        content="AI-powered local service advertising that keeps your calendar full. Build Facebook ads, Google ads, and more in minutes. No experience needed."
      />
      <meta property="og:url" content="https://adforge.ai/ai-ads-for-local-services" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="AI Ads for Local Services | AdForge" />
      <meta
        name="twitter:description"
        content="Stop wasting money on ads that don't get calls. AdForge builds AI ads for local service businesses in minutes. Free to start."
      />

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'AI Ads for Local Services — AdForge',
        description:
          'AdForge creates AI ads for local service businesses including plumbers, electricians, HVAC, cleaners, pest control, movers, and more. Generate Facebook ads and Google ads in minutes.',
        url: 'https://adforge.ai/ai-ads-for-local-services',
        mainEntity: {
          '@type': 'SoftwareApplication',
          name: 'AdForge AI Ad Generator for Local Services',
          applicationCategory: 'BusinessApplication',
          operatingSystem: 'Web',
          offers: {
            '@type': 'Offer',
            price: '0',
            priceCurrency: 'USD',
            description: 'Free plan available — no credit card required',
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '2450',
          },
        },
      })}</script>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          {
            '@type': 'Question',
            name: 'Do I need marketing experience to use AI ads for local services?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'No. AdForge is built for service business owners with zero marketing experience. You answer a few simple questions about your service and the AI does the rest — writing the copy, generating images, and formatting ads for Facebook, Instagram, and Google.',
            },
          },
          {
            '@type': 'Question',
            name: 'What types of local service businesses can use AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge works for virtually any local service business: plumbers, electricians, HVAC technicians, cleaners, pest control, movers, auto repair shops, tutors, pet groomers, lawn care, pressure washers, handymen, and more.',
            },
          },
          {
            '@type': 'Question',
            name: 'How much does local service advertising with AdForge cost?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'AdForge is free to start. Paid plans start at $29/month. Your actual Facebook or Google ad spend is separate and set by you directly in the ad platform.',
            },
          },
          {
            '@type': 'Question',
            name: 'How fast can I create local service ads with AdForge?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Most service business owners generate their first complete ad package — including copy, headlines, hooks, and AI images — in under 3 minutes.',
            },
          },
          {
            '@type': 'Question',
            name: 'Can AdForge target my specific city or service area?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Yes. AdForge writes copy tailored to your specific service area. You tell it your city or region and the AI naturally incorporates local relevance into your ad copy.',
            },
          },
        ],
      })}</script>

      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <LocalServicesHero />
          <LocalServicesPainPoints />
          <LocalServicesHowHelps />
          <LocalServicesExamples />
          <LocalServicesHowItWorks />
          <LocalServicesBenefits />
          <LocalServicesFAQ />
          <LocalServicesCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}
